import { useCallback, useMemo } from 'react';
import { BehaviorSubject } from 'rxjs';
import { ApiManagementFormState } from './api-management-form';

let stateSubject$: BehaviorSubject<ApiManagementFormState> | null = null;

export const useApiManagementState = () => {
  const state$ = useMemo(() => {
    if (!stateSubject$) {
      stateSubject$ = new BehaviorSubject<ApiManagementFormState>({
        exchanges: []
      });
    }
    return stateSubject$;
  }, []);

  const initializeState = useCallback(
    (state: ApiManagementFormState) => {
      state$.next(state);
    },
    [state$]
  );

  const addExchange = useCallback(
    (exchange: ApiManagementFormState['exchanges'][number]) => {
      const current = state$.getValue();
      state$.next({
        ...current,
        exchanges: [...current.exchanges, exchange]
      });
    },
    [state$]
  );

  return {
    state$,
    initializeState,
    addExchange
  };
};
